import { copy } from "shared/assets";
import { Message } from "shared/components";
import { IStatus, IAPIError } from "shared/types";

export interface APIErrorMessageProps {
  apiErrorMessage?: boolean | string | JSX.Element;
  apiError?: IAPIError | null;
}

export const APIErrorMessage = ({ apiError, apiErrorMessage }: APIErrorMessageProps) => (
  <Message status={IStatus.error}>
    {typeof apiErrorMessage === "boolean" ? copy.errors.general : apiErrorMessage}
    {apiError?.errorCodes?.[0] && ` (err: ${apiError?.errorCodes?.[0]})`}
  </Message>
);
